/**
 * Round a float number with tax and multiplier
 * @param {number} value - The base value
 * @param {number} tax - The tax/factor to apply
 * @param {number} mult - The multiplier for rounding precision
 * @returns {number} The rounded float value
 */
export const getRoundFloat = (value, tax, mult) => {
  return Math.round((value * tax + Number.EPSILON) * mult) / mult
}

/**
 * Convert string number (with comma) to float
 * @param {string|number} value - The value to convert
 * @returns {number|string} The parsed number or empty string if falsy
 */
export const getNumber = (value) => {
  if (value) {
    if (typeof value === 'string') {
      value = value.replace(',', '.')
      return parseFloat(value)
    }
    return value
  }
  return ''
}

/**
 * Round a float number and convert to string with comma separator
 * @param {number} value - The base value
 * @param {number} tax - The tax/factor to apply
 * @param {number} mult - The multiplier for rounding precision
 * @returns {string} The rounded number as string with comma separator
 */
export const getRound = (value, tax, mult) => {
  return getRoundFloat(value, tax, mult).toString().replace('.', ',')
}
